import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
  getLegEntity,
  getLegRegion,
  getOD,
  getTierAMR,
  getTripType,
} from '../newrelic-helpers';

export function nrFfnAssociation(globalState, actionName, fullStory, metricData) {
  const data = {
    actionSubname: PROFILE_SUBNAME.WEBFFNASSOCIATION,
    associationMethod: metricData?.action?.associationMethod,
    environment: getEnvironmentMicro(),
    errorCode: metricData?.action?.errorCode || '*',
    ffn: metricData?.action?.request?.accountNumber || '*',
    flow: 'MYB',
    fullstory: fullStory || DEFAULT_NA,
    lastName: metricData?.action?.request?.lastname || '*',
    legEntity: getLegEntity(globalState) || '*',
    legRegion: getLegRegion(globalState) || '*',
    loyaltyProgram: metricData?.action?.request?.loyaltyProgram || '*',
    reservationCode: metricData?.action?.request?.pnr || '*',
    request: metricData?.action?.request || '*',
    resultState: metricData?.resultState,
    route: getOD(globalState) || '*',
    storefront: metricData?.storefront,
    subflow: 'ancillary',
    tierAMR: getTierAMR(globalState) || '*',
    tripType: getTripType(globalState) || '*',
    url: window?.location?.href,
  };

  window.newrelic.addPageAction(actionName, data);
}
